import React from 'react';
import { useLoading } from '../context/LoadingContext';

const GlobalLoadingBar = () => {
  const { isLoading, progress } = useLoading();

  if (!isLoading) return null;

  return (
    <>
      {/* Loading bar at top of screen */}
      <div className="global-loading-bar">
        <div 
          className="global-loading-bar-progress"
          style={{ width: `${progress}%` }}
        />
      </div>

      <style>{`
        .global-loading-bar {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: rgba(255, 255, 255, 0.2);
          z-index: 99999;
          overflow: hidden;
        }

        .global-loading-bar-progress {
          height: 100%;
          background: linear-gradient(
            90deg,
            #667eea 0%,
            #764ba2 50%,
            #FFC421 100%
          );
          background-size: 200% 100%;
          animation: shimmer 1.5s ease-in-out infinite;
          transition: width 0.2s ease-out;
          box-shadow: 0 0 10px rgba(102, 126, 234, 0.7), 
                      0 0 20px rgba(118, 75, 162, 0.5);
        }

        @keyframes shimmer {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }
      `}</style>
    </>
  );
};

export default GlobalLoadingBar;
